import { backendClient } from "../../api/backend";
import * as types from "./types";

const setLoading = (loading) => ({ type: types.FACTURATION_SET_LOADING, payload: loading });
const setError = (error) => ({ type: types.FACTURATION_SET_ERROR, payload: error });

// ── Quotes ──────────────────────────────────────────────────────────────────

export const fetchQuotes = (params = {}) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await backendClient.getQuotes(params);
    dispatch({ type: types.FACTURATION_SET_QUOTES, payload: data });
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchQuote = (quoteId) => async (dispatch) => {
  try {
    const data = await backendClient.getQuote(quoteId);
    dispatch({ type: types.FACTURATION_SET_CURRENT_QUOTE, payload: data });
    return data;
  } catch (e) {
    dispatch(setError(e.message));
  }
};

export const createQuote = (data) => async (dispatch) => {
  const result = await backendClient.createQuote(data);
  dispatch(fetchQuotes());
  return result;
};

export const updateQuote = (quoteId, data) => async (dispatch) => {
  const result = await backendClient.updateQuote(quoteId, data);
  dispatch({ type: types.FACTURATION_SET_CURRENT_QUOTE, payload: result });
  dispatch(fetchQuotes());
  return result;
};

export const updateQuoteStatus = (quoteId, status) => async (dispatch) => {
  const result = await backendClient.updateQuoteStatus(quoteId, status);
  dispatch({ type: types.FACTURATION_SET_CURRENT_QUOTE, payload: result });
  dispatch({ type: types.FACTURATION_UPDATE_QUOTE_IN_LIST, payload: result });
  return result;
};

export const sendQuoteEmail = (quoteId) => async (dispatch) => {
  const result = await backendClient.sendQuoteEmail(quoteId);
  dispatch({ type: types.FACTURATION_SET_CURRENT_QUOTE, payload: result });
  dispatch(fetchQuotes());
  return result;
};

export const duplicateQuote = (quoteId) => async (dispatch) => {
  const result = await backendClient.duplicateQuote(quoteId);
  dispatch(fetchQuotes());
  return result;
};

export const deleteQuote = (quoteId) => async (dispatch) => {
  await backendClient.deleteQuote(quoteId);
  dispatch({ type: types.FACTURATION_REMOVE_QUOTE_FROM_LIST, payload: quoteId });
};

export const downloadQuotePdf = (quoteId, { clientName, lang } = {}) => async () => {
  const blob = await backendClient.downloadQuotePdf(quoteId);
  const prefix = lang === "en" ? "Quote" : "Devis";
  const name = clientName ? `${prefix} ${clientName}.pdf` : `${prefix}-${quoteId}.pdf`;
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

// ── Marketing Organizations ─────────────────────────────────────────────────

export const fetchMarketingOrgs = (search = '') => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const params = { page_size: 100 };
    if (search) params.search = search;
    const data = await backendClient.getMarketingOrganizations(params);
    dispatch({ type: types.FACTURATION_SET_MARKETING_ORGS, payload: data.items || data });
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchMarketingOrg = (orgId) => async (dispatch) => {
  try {
    const data = await backendClient.getMarketingOrganization(orgId);
    dispatch({ type: types.FACTURATION_SET_CURRENT_MARKETING_ORG, payload: data });
    return data;
  } catch (e) {
    dispatch(setError(e.message));
  }
};

export const createMarketingOrg = (data) => async (dispatch) => {
  const result = await backendClient.createMarketingOrganization(data);
  dispatch(fetchMarketingOrgs());
  return result;
};

export const updateMarketingOrg = (orgId, data) => async (dispatch) => {
  const result = await backendClient.updateMarketingOrganization(orgId, data);
  dispatch({ type: types.FACTURATION_SET_CURRENT_MARKETING_ORG, payload: result });
  dispatch(fetchMarketingOrgs());
  return result;
};

export const deleteMarketingOrg = (orgId) => async (dispatch) => {
  await backendClient.deleteMarketingOrganization(orgId);
  dispatch(fetchMarketingOrgs());
};

export const linkContactToOrg = (orgId, contactId) => async (dispatch) => {
  const result = await backendClient.linkContactToMarketingOrg(orgId, contactId);
  dispatch({ type: types.FACTURATION_SET_CURRENT_MARKETING_ORG, payload: result });
  return result;
};

export const unlinkContactFromOrg = (orgId, contactId) => async (dispatch) => {
  await backendClient.unlinkContactFromMarketingOrg(orgId, contactId);
  dispatch(fetchMarketingOrg(orgId));
};
